'use client'
import 'swiper/css'
import { Navigation } from 'swiper/modules'
import { SwiperSlide } from 'swiper/react'

import { FC, useRef } from 'react'

import { Block } from '@/app/graphql/generated'
import { AnimationShowBlockComponent } from '@/app/shared/components/animation/show-block'
import { CardReviewComponent } from '@/app/shared/components/reviews/elements/card-review'
import { IId } from '@/app/shared/interfaces/common.interface'
import { ITitle } from '@/app/shared/interfaces/content.interface'
import { clearData } from '@/app/shared/services/data-formatter'
import { ContainerComponent } from '@/app/shared/ui/container'
import { SliderComponent } from '@/app/shared/ui/slider'
import { SliderArrowComponent } from '@/app/shared/ui/slider-arrow'
import { TitleComponent } from '@/app/shared/ui/title' // interface

// interface
interface IReviews extends IId {
  data: Block
}

interface IReviewsQuery extends IId {
  title: ITitle
}

// component
const ReviewsComponent: FC<Readonly<IReviews>> = ({ data, id }) => {
  const btnEL = useRef<HTMLButtonElement | null>(null)

  const dataReviews = clearData(JSON.parse(data?.contentAll ?? '')) as IReviewsQuery

  const sliderItems = data.feedbacks

  return (
    <div>
      <ContainerComponent className={'relative'} id={id}>
        <TitleComponent className={'mb-[30px] laptop:mb-[50px]'} animate>
          {dataReviews.title.title}
        </TitleComponent>
        <AnimationShowBlockComponent
          className={
            'absolute left-[30%] top-[calc(100%-20px)] z-10 hidden -translate-y-1/2 laptop:flex'
          }
          initial={{
            opacity: 0,
            y: 30,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
            amount: 0,
          }}
        >
          <SliderArrowComponent
            button={'prev'}
            ref={btnEL}
            className={
              'border-warning-foreground bg-content1-200 text-content2-100 data-[hover="true"]:!border-warning data-[hover="true"]:!bg-warning laptop:flex'
            }
          />
        </AnimationShowBlockComponent>
      </ContainerComponent>
      <AnimationShowBlockComponent
        initial={{
          opacity: 0,
          y: 30,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
      >
        <SliderComponent
          modules={[Navigation]}
          slidesPerView={1.1}
          spaceBetween={10}
          centeredSlides={true}
          breakpoints={{
            576: {
              slidesPerView: 'auto',
              spaceBetween: 0,
              centeredSlides: false,
            },
          }}
          loop={(sliderItems?.length ?? 0) > 3}
          onBeforeInit={(swiper) => {
            const navigation = swiper.params.navigation

            if (!navigation || !btnEL.current) return

            if (typeof navigation !== 'boolean') {
              navigation.prevEl = btnEL.current
            }
          }}
        >
          {sliderItems?.map((el, index) => (
            <SwiperSlide
              key={`${el?.id}_${index}`}
              className={'mobile:mr-[20px] mobile:!w-[480px]'}
            >
              <CardReviewComponent data={el} />
            </SwiperSlide>
          ))}
        </SliderComponent>
      </AnimationShowBlockComponent>
    </div>
  )
}

export default ReviewsComponent
